// Trip status buckets based on legacy account app semantics
export const POSITIVE_TRIP_STATUSES = [
    'upcoming',
    'approved',
    'payment details confirmed',
    'payment complete',
    'confirmed',
    'refund complete',
    'e-ticket sent',
    'pnr received',
    'booking confirmed',
    'refunded',
    'rescheduled',
    'rescheduled by airline'
]

export const NEGATIVE_TRIP_STATUSES = [
    'payment failed',
    'rejected',
    'elapsed',
    'discarded',
    'no show',
    'booking dropped',
    'payment unsuccessful',
    'cancelled',
    'booking failed',
    'expired',
    'refund failed'
]

export const PROGRESS_TRIP_STATUSES = [
    'on hold',
    'open ticket pending',
    'processing e-ticket',
    'awaiting pnr',
    'processing payment',
    'initiating refund',
    'payment initialized',
    'payment initiated',
    'refund processed',
    'processing',
    'payment processing'
]

export const FLIGHT_TRIP_TYPES = ['air', 'flight', 'fph', 'R']
export const HOTEL_TRIP_TYPES = ['hotel', 'H', 'h', 'fph']

